import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { isValid, parseISO } from 'date-fns';
import { CaseData } from 'src/app/models/case-data.model';
import { TranslateModule } from '@ngx-translate/core';
import { DecimalPipe, DatePipe } from '@angular/common';

@Component({
  selector: 'app-countdown',
  templateUrl: './countdown.component.html',
  styleUrls: ['./countdown.component.scss'],
  imports: [TranslateModule, DecimalPipe, DatePipe],
})
export class CountdownComponent implements OnInit, OnDestroy {
  @Input({ required: true }) caseData!: CaseData;
  day: string | number;
  hour: string | number;
  minute: string | number;
  second: string | number;
  firstPaymentPlanDueDate: string = null;

  countdownInterval: ReturnType<typeof setInterval>;
  get showHardAmount(): boolean {
    return (
      !this.caseData.is_payment_plan &&
      this.caseData.amount_after_legal_fees !== null
    );
  }

  ngOnInit(): void {
    this.findFirstPP();

    this.countdown();
    this.countdownInterval = setInterval(this.countdown, 1000);
  }

  ngOnDestroy() {
    clearInterval(this.countdownInterval);
  }

  countdown = () => {
    const now = new Date();
    const endRaw = this.caseData.is_payment_plan
      ? this.firstPaymentPlanDueDate
      : this.caseData.hard_collection_at;
    const end = parseISO(endRaw);

    if (!isValid(end)) {
      this.day = 'NaN';
      this.hour = 'NaN';
      this.minute = 'NaN';
      this.second = 'NaN';
      return;
    }

    const totalSeconds = Math.max(
      0,
      Math.floor((end.getTime() - now.getTime()) / 1000),
    );

    this.day = Math.floor(totalSeconds / 86_400);
    this.hour = Math.floor((totalSeconds % 86_400) / 3_600);
    this.minute = Math.floor((totalSeconds % 3_600) / 60);
    this.second = totalSeconds % 60;
  };

  findFirstPP() {
    if (!this.caseData.is_payment_plan) {
      return;
    }

    for (const pp of this.caseData.payment_plans) {
      if (pp.status === 'pending') {
        this.firstPaymentPlanDueDate = pp.dueDate;
        break;
      }
    }
  }
}
